module.exports = __webpack_public_path__ + "img/pg.7f02140d.png";